import { Container, Divider, Heading } from "@chakra-ui/react";
import CardForm from "components/ui/CardForm";
import HeaderBarInternal from "components/ui/HeaderBarInternal";
import { useResource } from "hooks/useResource";
import { useParams } from "react-router-dom";
import PLForm from "../components/PLForm";

export default function PageEditPL() {
  const { id } = useParams();
  const { data: pl } = useResource({
    id: id as string,
    resourceName: "pl",
    path: "pls",
  });

  return (
    <>
      <HeaderBarInternal title="Editar proposição legislativa" backTo="/pls" />
      <Divider />

      <Container variant="internal" flexDirection="column">
        <Heading as="h1" size="h1">
          Dados da proposição legislativa
          <span>Edite os dados da proposição legislativa</span>
        </Heading>

        <CardForm>{pl && <PLForm pl={pl} />}</CardForm>
      </Container>
    </>
  );
}
